import { convertExcelDate } from '../../zusatztools/routinen/importUtil';
import { ExcelTool } from '../../../core/excel/excel_tool';
import { WorkBook } from 'xlsx/types';

export function importLastgang(excel: ExcelTool, wb: WorkBook): Array<any> {
    const sheetNames = excel.getSheetNames(wb);
    const sheetData = excel.getJSON(wb, sheetNames[0]);
    // console.log('sheetData Lastgang', sheetData);

    const items = sheetData.map((row: Array<any>, idx: number) => {
        if (idx === 0) {
            return;
        }
        if (idx >= 100) {
            // return;
        }
        const dateObj = convertExcelDate(row[0]);
        const date = dateObj.getTime();
        // Aus Excel kommt fälschlicherweise UTC --> deshalb bei der Zeit den Offset berücksichtigen (der kommt in Minuten)

        const offset = dateObj.getTimezoneOffset() * 60 * 1000;
        const time = row[1] * 86400000;
        const stamp = date + time + offset;
        const datetime = new Date(stamp);
        const value = row[2];
        return { datetime, value };
        // console.log('Row', idx,  time, date, datetime, value, offset);
    });

    return items;
}
